import { Route } from '@angular/router';
import { BusinessAccountListComponent } from '../modules/elevate/component/business-account-list/business-account-list.component';

export const elevateRoute: Route = {
  path: 'elevate',
  data: { title: 'Elevate' },
  loadChildren: () => import('./../modules/elevate/elevate.module').then((m) => m.ElevateModule),
};
